/* Allorn: products with an English and a Swedish version render thumbnails for both languages.
   Dawn swaps the main images when the Language variant changes; this keeps the thumbnail strip in step
   by showing only the thumbnails whose image is in the main gallery. */
(() => {
  const sync = (gallery) => {
    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    const thumbs = gallery.querySelector('[id^="GalleryThumbnails"]');
    if (!viewer || !thumbs) return;
    const shown = new Set([...viewer.querySelectorAll('li[data-media-id]')].map((li) => li.dataset.mediaId));
    let first = null;
    thumbs.querySelectorAll('li[data-target]').forEach((li) => {
      const on = shown.has(li.dataset.target);
      li.classList.toggle('hidden', !on);
      if (on && !first) first = li;
    });
    const active = viewer.querySelector('li.is-active');
    thumbs.querySelectorAll('button[aria-current]').forEach((b) => b.removeAttribute('aria-current'));
    const current = active && thumbs.querySelector(`li[data-target="${active.dataset.mediaId}"] button`);
    (current || (first && first.querySelector('button')))?.setAttribute('aria-current', 'true');
  };
  const watch = () => {
    document.querySelectorAll('media-gallery').forEach((gallery) => {
      const viewer = gallery.querySelector('[id^="GalleryViewer"]');
      if (!viewer || gallery.dataset.alLangWatch) return;
      gallery.dataset.alLangWatch = '1';
      new MutationObserver(() => sync(gallery)).observe(viewer, { childList: true, subtree: true });
    });
  };
  // On the Arabic site, open products on the Arabic version when it's on sale (unless a variant is in the URL).
  const preferArabic = () => {
    if (!(document.documentElement.lang || '').startsWith('ar') || /[?&]variant=/.test(location.search)) return;
    const vs = document.querySelector('variant-selects');
    if (!vs || !/\/products\//.test(location.pathname)) return;
    // only switch when the Arabic version can actually be bought
    fetch(`${location.pathname.replace(/\/$/, '')}.js`, { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((p) => {
        const ar = (p.variants || []).find((v) => (v.options || []).some((o) => o === 'العربية' || o === 'Arabic'));
        if (!ar || !ar.available) return;
        const input = [...vs.querySelectorAll('input[type="radio"]')].find((i) => i.value === 'العربية' || i.value === 'Arabic');
        if (!input || input.checked) return;
        const label = vs.querySelector(`label[for="${input.id}"]`);
        (label || input).click();
      })
      .catch(() => {});
  };
  const start = () => { watch(); preferArabic(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', watch);
})();
